<span [matTooltip]="'Currency code: ' + currency">{{ value | adminCurrency: currency }}</span>
